import type { MenuScreen } from '../types.js';
import { createScreenShell, createCrestButton, createDivider, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';

const VERSION = '0.1.0';

export function createAboutScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const body = shell.body;

      const center = el('div', { class: 'about-center' }, [
        el('div', { class: 'about-line about-line--lead', text: t('app.name') }),
        el('div', { class: 'about-divider' }, [createDivider()]),
        el('div', { class: 'about-line about-line--meta', text: t('about.version', { version: VERSION }) }),
        el('div', { class: 'about-line about-line--dim', text: t('about.tech') }),
      ]);

      const back = el('div', { class: 'button-row back-button-row' }, [
        createCrestButton({ label: t('common.back'), small: true, onClick: () => ctx.navigate('menu') }),
      ]);

      body.appendChild(center);
      body.appendChild(back);
      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
